/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Gps_History_No_SegmentsInputs */

const vi_vehicle_gps_history_no_segments = /** @type {(inputs: Vehicle_Gps_History_No_SegmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có chặng hành trình trong khoảng thời gian này`)
};

/**

* @param {Vehicle_Gps_History_No_SegmentsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_gps_history_no_segments = /** @type {((inputs?: Vehicle_Gps_History_No_SegmentsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Gps_History_No_SegmentsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_gps_history_no_segments(inputs)
});